export class ForgotPasswordData {
    PatientId: string;
    UserName: string;
    Email: string;
    Authentication: string;
    IsValid: boolean;
    page: string;
    pageSize: string;
    Pid: string;
    constructor(patientid: string, username: string, email: string, authen: string) {
        this.PatientId = patientid;
        this.UserName = username;
        this.Email = email;
        this.Authentication = authen;
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/usersecurity/forgotpassworddata.ts